import React from "react";
import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import StyledHeadingText from "./Fonts/StyledHeadingText";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const LineChart = ({ dataPoints, label }) => {
    const labels = dataPoints.map((_, index) => ``);

    console.log(dataPoints);
    

    // Line chart configuration
    const data = {
        labels,
        datasets: [
            {
                label: "Ratings",
                data: dataPoints,
                borderColor: "#3d77a8",
                borderWidth: 1,
                tension: 0.1,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: true,
            },
        },
        scales: {
            y: {
                title: {
                    display: false,
                },
                ticks: {
                    stepSize: 1,
                },
                grid: {
                    drawTicks: true,
                    color: "#D3D3D3",
                },
            },
        },
    };

    return (
        <div>
            {label ? <StyledHeadingText text={label} /> : <></>}
            <Line className="mt-2" data={data} options={options} />
        </div>
    );
};

export default LineChart;
